import { notifications } from '@mantine/notifications'
import type { QueryClient } from '@tanstack/react-query'
import { useQueryClient } from '@tanstack/react-query'

import { INVALIDATE_KEYS } from '@/constants/invalidateAccountQueryKeys.constants'

import {
  useBankingServiceBankingControllerDeleteAccount,
  useBankingServiceBankingControllerDeleteManualAccount,
} from '@/__generated__/queries'

function handleSuccess(queryClient: QueryClient) {
  notifications.show({
    color: 'green',
    message: 'Account has been successfully deleted',
    title: 'Account deleted',
  })

  INVALIDATE_KEYS.forEach(key => {
    queryClient.invalidateQueries({
      queryKey: [key],
    })
  })
}

export function useAccountItemDelete(accountId: string) {
  const queryClient = useQueryClient()

  const deleteMutation = useBankingServiceBankingControllerDeleteAccount({
    onSuccess: () => {
      handleSuccess(queryClient)
    },
  })

  return {
    deleteAccount: () => deleteMutation.mutate({ accountId }),
  }
}

export function useManualAccountItemDelete(accountId: string) {
  const queryClient = useQueryClient()

  const deleteMutation = useBankingServiceBankingControllerDeleteManualAccount({
    onSuccess: () => {
      handleSuccess(queryClient)
    },
  })

  return {
    deleteManualAccount: () =>
      deleteMutation.mutate({ accountId: accountId.replace('manual-', '') }),
  }
}
